import axios from "axios";
import Constants from "expo-constants";
import AsyncStorage from "@react-native-async-storage/async-storage";

// A URL da API vem de app.json > expo.extra.apiUrl, sobrescrita por API_URL em
// tempo de build/start (perfis do eas.json para nativo, ou `API_URL=... expo
// start/export:web` para Web). Isso vale para todas as plataformas — inclusive
// Web, que em produção (PWA em app.f5logi.com.br) precisa da URL absoluta da
// API (api.f5logi.com.br), liberada via CORS_ORIGINS no backend.
//
// Só ao rodar `expo start --web` LOCALMENTE aponte API_URL=/api: nesse caso o
// devServer do webpack proxeia /api para a API real (ver webpack.config.js),
// evitando o CORS que bloquearia uma chamada cross-origin direto do browser
// em dev. Isso não existe no build estático de produção, por isso lá a URL
// tem que ser absoluta.
const apiUrl =
  (Constants.expoConfig?.extra?.apiUrl as string | undefined) ??
  "http://localhost:5001/api";

export const api = axios.create({
    baseURL: apiUrl,
});

// Injeta o token de acesso em toda requisição autenticada.
// O backend (FastAPI) usa HTTPBearer, então o header correto é Authorization: Bearer.
api.interceptors.request.use(async (config) => {
    const token = await AsyncStorage.getItem("@lmatransportes:accessToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
